import React from 'react'
import styles from './cart.module.css';
import Button from '../Button';
import {withRouter} from 'react-router-dom';

export const CheckoutButton = withRouter(() => {
  const cherry = 'https://shop.cherry.de/';

  return (
    <Button url={cherry} className={styles.checkoutButton}>Buy at Cherry Shop</Button>
  );
});
